import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError, EMPTY } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  catchError,
  map,
  publishReplay,
  refCount,
  share,
} from 'rxjs/operators';
import { AppConfigService } from '../services/config.service';

let headers = new HttpHeaders({
  // 'Content-Type': 'application/json',
  user_token: 'abc',
});
let options = { headers: headers };

@Injectable({
  providedIn: 'root',
})
export class AuthServiceService {
  public _patient;
  public _billItem;
  isLogedIn = JSON.parse(localStorage.getItem('loggedIn' || 'false'));

  private url = this.conf.appConfig.apiBaseUrl;
  // private onlineUrl = 'http://selfserviceapi.everightlab.com';
  private onlineUrl = this.conf.appConfig.apiOnlineBaseUrl; // 'https://everight-hms-api.azurewebsites.net';
  private nodeAPI = this.conf.appConfig.nodeBaseUrl;

  setLogedin(value: boolean) {
    // this.isLogedIn = value;
    localStorage.setItem('loggedIn', 'true');
  }

  setLogedout(value: boolean) {
    // this.isLogedIn = value;
    localStorage.setItem('loggedIn', 'false');
  }

  get loggedIn() {
    return JSON.parse(
      localStorage.getItem('loggedIn' || this.loggedIn.toString())
    );
  }
  get patient() {
    return this._patient;
  }
  get billItem() {
    return this._billItem;
  }

  currentPatient(patient) {
    this._patient = patient;
  }

  currentBillItem(billItem) {
    this._billItem = billItem;
  }

  isloggedIn() {
    const url = `${this.url}/api/accounts/user/getMyProfile`;

    return this.client.get<any>(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  login(username, password) {
    const data = {
      username,
      password,
    };
    console.log(data);
    localStorage.clear();
    const url = `${this.url}/api/accounts/user/login`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  resetPassword(userEmail) {
    const data = {
      userEmail,
    };
    console.log(data);
    const url = `${this.nodeAPI}/api/Notifications/recoverPassword`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  changePassword(userEmail, refNo, password, confirmPassword) {
    const data = {
      userEmail,
      refNo,
      password,
      confirmPassword,
    };
    console.log(data);
    const url = `${this.nodeAPI}/api/Notifications/resetPassword`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  loginOnline(username, password) {
    const data = {
      username,
      password,
    };
    console.log(data);
    const url = `${this.onlineUrl}/api/accounts/user/login`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  SignUp(
    Employee_id,
    First_Name,
    Middle_Name,
    Last_Name,
    U_Name,
    Position_Id,
    Address,
    Phone_No,
    Email_id,
    Flag,
    designation,
    signature,
    password,
    IsDeleted,
    qualification,
    CanAuthDiscount
  ) {
    const data = {
      Employee_id,
      First_Name,
      Middle_Name,
      Last_Name,
      U_Name,
      Position_Id,
      Address,
      Phone_No,
      Email_id,
      Flag,
      designation,
      signature,
      password,
      IsDeleted,
      qualification,
      CanAuthDiscount,
    };
    console.log(data);
    const url = `${this.onlineUrl}/api/accounts/user/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  // errorHandler(error: any) {
  //   return throwError(error || 'error please try again');
  // }

  constructor(private client: HttpClient, private conf: AppConfigService) {}
}
